export default "__VITE_ASSET__6896a857__"